/* === Libellés par défaut des composants ag-ui === */

/**
 * Noms accessibles et textes que les composants ag-ui posent d'eux-mêmes quand
 * l'appelant n'en fournit pas. Un seul endroit, en français : un lecteur d'écran
 * ne doit jamais annoncer « Close modal » dans un produit francophone.
 */
export const AG_LABELS = {
  /** Croix d'`AgModal`. */
  fermer: 'Fermer',
  /** Bouton de fermeture d'`AgAlert`. */
  fermerMessage: 'Fermer le message',
  /** Bouton de retrait d'`AgChip`. */
  retirer: (libelle: string): string => `Retirer ${libelle}`,
  /** Nom accessible d'`AgSpinner`. */
  chargement: 'Chargement',
  /** Nom du groupe d'`AgRating` quand l'appelant ne le nomme pas. */
  importance: 'Importance',
  /** Pastille seule (`dot`) d'`AgBadge` sans nom fourni. */
  notification: 'Notification',
  /** Compte d'`AgBadge` sans nom fourni. */
  notifications: (compte: string): string => `${compte} notifications`,
} as const;
